export default __webpack_public_path__ + "static/media/team4.c353ad6b.png";